import * as React from 'react';
import { SVGProps } from 'react';

const EyeFilledIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <g
      stroke={props.stroke || '#32324C'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth || 1.25}
      clipPath="url(#a)"
    >
      <path d="M6.667 8a1.333 1.333 0 1 0 2.666 0 1.333 1.333 0 0 0-2.666 0Z" />
      <path d="M14 8c-1.6 2.667-3.6 4-6 4s-4.4-1.333-6-4c1.6-2.667 3.6-4 6-4s4.4 1.333 6 4Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default EyeFilledIcon;
